import { render, staticRenderFns } from "./lendr.vue?vue&type=template&id=054cb223&"
import script from "./lendr.vue?vue&type=script&lang=js&"
export * from "./lendr.vue?vue&type=script&lang=js&"
import style0 from "./lendr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports